import { css } from '@emotion/react';
import { SrOnly, SrOnlyFocusable } from '../mixins/_screen-reader.mixin'

export default $ => css`
  .sr-only {
    ${new SrOnly().include($)}
  }

  .sr-only-focusable {
    ${new SrOnlyFocusable().include($)}
  }
`;
